<template>
    <div class="officialbar">
        <div v-show="isOfficial" class="top_official flex_r">
            <div class="flex_r">
                <img :src="require('@/common/images/activeTools/inform.png')" />
                <span>关注公众号，及时接收活动相关信息</span>
            </div>
            <div class="flex_r">
                <span @click="officialEvent">立即关注</span>
                <img :src="require('@/common/images/activeTools/close_code.png')" @click="hideDialog" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OfficialBar',
    data() {
        return {
            isOfficial: true
        }
    },
    methods: {
        showDialog(options) {
            console.log(options)
        },
        officialEvent() {
            this.$emit('showOfficialImg')
        },
        hideDialog() {
            this.isOfficial = false
        }
    }
}
</script>

<style lang="scss">
.flex_r {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.officialbar {
    .top_official {
        padding: 0 .3rem;
        height: .8rem;
        background: #fff;
        >div {
            img {
                display: inline-block;
                width: .3rem;
                height: .3rem;
            }
            img:nth-child(1){
                margin-right: .2rem;
            }
            img:nth-child(2){
                margin-left: .2rem;
            }
        }
        >div:nth-child(2) {
            span {
                width: 1.2rem;
                height: .4rem;
                line-height: .4rem;
                color: #F56C6C;
                font-size: .22rem;
                border: 1px solid #F56C6C;
                text-align: center;
                border-radius: .2rem;
            }
        }
    }
}
</style>


